import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as rootActions } from '../actions';
import { NAME as PRODUCT_NAME } from '../reducer';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { Button } from '@material-ui/core';
import SearchedTable from "../../../components/SearchedTable";

function mapStateToProps(state) {
  return {
    ...state[PRODUCT_NAME]
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...rootActions
}, dispatch);

class ListProduct extends React.Component {
  constructor(props) {
    super(props);
    // Fetch product list when the component mounts
    this.fetchProductList(props.companyId);
  }

  componentDidUpdate(prevProps) {
    // Fetch product list if companyId prop changes
    if (prevProps.companyId !== this.props.companyId) {
      this.fetchProductList(this.props.companyId);
    }
  }

  fetchProductList = (companyId) => {
    if (companyId) {
      this.props.getProductList({ companyId });
    }
  };

  render() {
    return (
      <Grid component={Paper} container spacing={3}>
        <Grid item xs={12}>
          {this.props.companyType !== 'Сельхозпроизводитель' && ( // условное отображение кнопки
            <FormControl fullWidth>
              <Button variant="outlined" color="primary" onClick={this.props.editAction}>
                Создать новый товар
              </Button>
            </FormControl>
          )}
        </Grid>
        <FormControl fullWidth>
          <SearchedTable
            tableTitle="Список товаров"
            tableDescription={{
              columns: this.props.tableColumns,
              data: this.props.productsList
            }}
            clickAction={(rowData, rowMeta) => {
              let id = rowData[0];
              this.props.setCurrentProduct(id);
            }}
          />
        </FormControl>
      </Grid>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListProduct);
